<template>
  <notifications :speed="200">
    <template #body="{ item, close }">
      <div class="alert">
        <div class="alert__header" :class="{ 'alert__header--detailed': item.data.isDetailed }">
          <atomic-icon class="alert__icon" :class="`alert__icon--${item.type}`" :id="types[item.type]" />

          <div class="alert__title" :class="{ 'alert__title--detailed': item.data.isDetailed }">
            {{ item.title }}
          </div>
        </div>

        <p v-if="item.data.isDetailed" class="alert__text" v-html="item.text" />

        <button v-if="item.data.isDetailed" class="alert__btn-close" @click="close">
          <atomic-icon id="close" />
        </button>

        <div v-if="item.data.isDetailed" class="alert__progress-bar" />
      </div>
    </template>
  </notifications>
</template>

<script setup lang="ts">
  const types: { [index: string]: string } = {
    success: 'done',
    error: 'warning',
    attention: 'attention',
    waiting: 'clock',
  };
</script>

<style src="~/assets/styles/components/atomic/alert.scss" lang="scss" />
